import { set } from 'cerebral/operators'
import { state, props } from 'cerebral/tags'

const onDeselectTag = hooks => {
  return [
    ({ props, state }) => {
      const option = state.get(
        `selectr.${props.namespace}.selected.${props.index}`
      )
      state.push(`selectr.${props.namespace}.options`, { label: option.label })
      state.splice(`selectr.${props.namespace}.selected`, props.index, 1)
      return { value: option.label }
    },
    set(props`payload`, state`selectr.${props`namespace`}.payload`),
    ...hooks.unSelectOption
  ]
}

export default onDeselectTag
